import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22dd147e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "edit-reg-line" }
const _hoisted_2 = { class: "edit-reg-line__title" }
const _hoisted_3 = { class: "edit-reg-line__info" }
const _hoisted_4 = { class: "edit-reg-line__name" }
const _hoisted_5 = { class: "edit-reg-line__desc" }
const _hoisted_6 = { class: "edit-reg-line__time-wrap" }
const _hoisted_7 = { class: "edit-reg-line__total" }
const _hoisted_8 = {
  key: 0,
  class: "edit-reg-line__max-error"
}
const _hoisted_9 = {
  key: 1,
  class: "edit-reg-line__max-error"
}
const _hoisted_10 = {
  key: 2,
  class: "edit-reg-line__max-error"
}

import { computed, ref, toRefs, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";

import { Validators } from "mq-ui-kit/lib/form-validate";
import { Button } from "mq-ui-kit/lib/Button";
import { DatePicker } from "mq-ui-kit/lib/DatePicker";
import { FormControlModel } from "mq-ui-kit/lib/form-control-model";
import { FormRow } from "mq-ui-kit/lib/FormRow";
import { FormColumn } from "mq-ui-kit/lib/FormColumn";
import { FormLabel } from "mq-ui-kit/lib/FormLabel";
import ToastService from "mq-ui-kit/lib/toast";
import { getCookie } from "typescript-cookie";
import ActionTypes from "@/store/types/action-types";
import OverlayDialog from "@/components/ui/OverlayDialog.vue";
import Avatar from "@/components/ui/Avatar.vue";
import { CookieProps } from "@/types/global";
import localeList from "@/helpers/langLocale";

interface Props {
  isOpen: boolean,
  registration?: any
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EditRegistrationLineModal',
  props: {
    isOpen: { type: Boolean, default: false },
    registration: { default: {} }
  },
  emits: ["close", "cancel-dialog"],
  setup(__props: any, { emit }: { emit: ({
  (e: "close"): void,
  (e: "cancel-dialog"): void,
}), expose: any, slots: any, attrs: any }) {

const props = __props as { isOpen: boolean, registration: any };





const { registration: registrationHolder, isOpen } = toRefs(props);
const { t } = useI18n();
const store = useStore();

// value for max break time of 1 hour
const maxDateValue = ref(new Date(new Date().setHours(24, 0)));

const totalTime = ref(0) as any;
const maxTotalTime = ref("");
// if new total is bigger then old totalTime
const isTotalTimeError = ref(false);
// if shift is overlapping to next day
const isEndOnNextDay = ref(false);
// if total time is negative
const isTotalTimeNegative = ref(false);
const isLoading = ref(false);

// hardcoded for MEP to have 15min step on pickers
const realmName = computed(() => getCookie(CookieProps.RealmName) as string);
const timeStep = computed(() => realmName.value === "cp-mep" ? 15 : 1);

const startTime = ref(new FormControlModel({
  validations: [
    Validators.required(),
  ],
  value: new Date(new Date().setHours(0, 0)),
}));

const endTime = ref(new FormControlModel({
  validations: [
    Validators.required(),
  ],
  value: new Date(new Date().setHours(0, 0))
}));

const breakTime = ref(new FormControlModel({
  validations: [
    Validators.required(),
  ],
  value: new Date(new Date().setHours(0, 0)),
  disabled: false,
}));

const addZeroToTime = (time: string | number) => (`0${time}`).slice(-2);

const getTimeFromDate = (time: string | Date) => {
  // get time string "10:20:30" from Date
  const holder = new Date(time);

  const hours = addZeroToTime(holder.getHours());
  const minutes = addZeroToTime(holder.getMinutes());
  const seconds = addZeroToTime(holder.getSeconds());

  return `${hours}:${minutes}:${seconds}`;
};

const getDateFromTime = (time: string, date: string | Date) => {
  // set time string "10:20:30" to provided Date
  const timeString = time;
  const dateHolder = new Date(date);

  if(time.length !== 8) throw new Error("Time string is in invalid format");

  const [hours, minutes, seconds] = timeString.split(":").map(Number);

  dateHolder.setHours(hours);
  dateHolder.setMinutes(minutes);
  dateHolder.setSeconds(seconds);

  return dateHolder;
}

const getMinutesDiffBetweenDates = (startDate: Date, endDate: Date) => {
  const startMinutes = (new Date(startDate).getHours() * 60) + new Date(startDate).getMinutes();
  const endMinutes = (new Date(endDate).getHours() * 60) + new Date(endDate).getMinutes();

  if (startMinutes > endMinutes) {
    isEndOnNextDay.value = endMinutes > 0;
    return (endMinutes + 1440) - startMinutes;
  } if (startMinutes === endMinutes) {
    isEndOnNextDay.value = false;
    return 0;
  }

  isEndOnNextDay.value = false;

  return endMinutes - startMinutes;
};

const minToHoursWithMin = (totalMinutes: number) => {
  const totalAbs = Math.abs(totalMinutes);
  const hours = Math.floor(totalAbs / 60);
  const minutes = totalAbs % 60;

  return `${addZeroToTime(Math.abs(hours))}:${addZeroToTime(Math.abs(minutes))}`;
};

const getTotalTime = (start: string, end: string) => {
  const startEndDiff = getMinutesDiffBetweenDates(new Date(start), new Date(end)) as number;

  const breakVal = breakTime.value.getValue() as string;
  const breakMinutes = (new Date(breakVal).getHours() * 60) + new Date(breakVal).getMinutes();

  const allDiff = startEndDiff - breakMinutes;

  isTotalTimeNegative.value = allDiff < 0;

  return allDiff < 0 ? `-${minToHoursWithMin(allDiff)}` : minToHoursWithMin(allDiff);
};

const dateFormat = (item: Date) => {
  const customDate = new Date(item);

  if (localeList.dutchLocaleList.includes(window.navigator.language)) {
    return customDate.toLocaleDateString("nl-NL");
  }

  return customDate.toLocaleDateString("en-GB");
};

const timeChangeBlur = () => {
  totalTime.value = getTotalTime(startTime.value.getValue() as string, endTime.value.getValue() as string);

  const totalSplit = totalTime.value.split(":");
  const maxTotalSplit = maxTotalTime.value.split(":");

  const totalMin = (Number(totalSplit[0]) * 60) + Number(totalSplit[1]);
  const maxTotalMin = (Number(maxTotalSplit[0]) * 60) + Number(maxTotalSplit[1]);

  isTotalTimeError.value = totalMin > maxTotalMin;
}

const setStartingValues = () => {
  startTime.value.setValue(new Date(registrationHolder?.value.dateTimeRange?.startTimestamp));
  endTime.value.setValue(new Date(registrationHolder?.value.dateTimeRange?.endTimestamp));

  breakTime.value.setValue(
    getDateFromTime(registrationHolder?.value.breakDuration, (new Date().setHours(0,0,0) as any))
  );

  totalTime.value = getTotalTime(registrationHolder?.value.dateTimeRange?.startTimestamp,
      registrationHolder?.value.dateTimeRange?.endTimestamp);

  maxTotalTime.value = totalTime.value;

  isEndOnNextDay.value = false;
  isTotalTimeError.value = false;
  isTotalTimeNegative.value = false;
}

const closeDialog = () => {
  emit("close");
};

const cancelDialog = () => {
  emit("cancel-dialog");
};

const save = () => {
  if (
    startTime.value.valid
    && endTime.value.valid
    && breakTime.value.valid
    && !isTotalTimeError.value
    && !isTotalTimeNegative.value
  ) {
    const params = {
      editShiftRegistrationDto: {
        registrationId: registrationHolder.value.registrationId,
        registrationClass: registrationHolder.value.registrationClass,
        employeeId: registrationHolder.value.employeeData.employeeId,
        startTime: getTimeFromDate(startTime.value.getValue() as Date),
        endTime: getTimeFromDate(endTime.value.getValue() as Date),
        breakDuration: getTimeFromDate(breakTime.value.getValue() as Date),
        quantity: `${totalTime.value}:00`,
        registrationUnit: registrationHolder.value.unit
      }
    };

    isLoading.value = true;

    store
    .dispatch(ActionTypes.EDIT_REGISTRATION_CLIENT_EMPLOYEE, params)
    .then(() => {
      ToastService.successToast(t("success_msg.changes_saved"));
      closeDialog();
    })
    .catch((err) => {
      console.log("Error:", err);
      ToastService.errorToast(t("errors.something_went_wrong"));
    })
    .finally(() => {
      isLoading.value = false;
    });
  }
};

const cancel = () => {
  cancelDialog();
};

watch(() => isOpen.value, (val) => {
  if(val) {
    setStartingValues();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(OverlayDialog, {
    "modal-id": "edit-registration-line",
    "is-open": _unref(isOpen),
    onClose: closeDialog
  }, {
    header: _withCtx(() => []),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t('edit_registration_line')), 1),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(Avatar, {
            name: __props.registration?.employeeData?.firstName,
            "last-name": __props.registration?.employeeData?.lastName,
            "img-path": __props.registration?.employeeData?.profilePictureUrl,
            "custom-size": 64,
            "custom-font-size": 24
          }, null, 8, ["name", "last-name", "img-path"]),
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(__props.registration?.employeeData?.fullName), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(__props.registration?.shiftData?.shiftName ?? _ctx.$t("not_applicable")) + " - " + _toDisplayString(dateFormat(__props.registration?.startDate)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_unref(FormColumn), null, {
            left: _withCtx(() => [
              _createVNode(_unref(FormLabel), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('global.start_time')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(DatePicker), {
                placeholder: _ctx.$t('global.start_time'),
                control: startTime.value,
                "time-only": "",
                "step-minute": _unref(timeStep),
                onBlur: timeChangeBlur,
                "manual-input": false
              }, null, 8, ["placeholder", "control", "step-minute"])
            ]),
            right: _withCtx(() => [
              _createVNode(_unref(FormLabel), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('global.end_time')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(DatePicker), {
                placeholder: _ctx.$t('global.end_time'),
                control: endTime.value,
                "time-only": "",
                "step-minute": _unref(timeStep),
                onBlur: timeChangeBlur,
                "manual-input": false
              }, null, 8, ["placeholder", "control", "step-minute"])
            ]),
            _: 1
          }),
          _createVNode(_unref(FormRow), null, {
            default: _withCtx(() => [
              _createVNode(_unref(FormLabel), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('global.break_duration')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(DatePicker), {
                placeholder: _ctx.$t('global.break_duration'),
                control: breakTime.value,
                "time-only": "",
                "step-minute": _unref(timeStep),
                "max-date": maxDateValue.value,
                onBlur: timeChangeBlur,
                "manual-input": false
              }, null, 8, ["placeholder", "control", "step-minute", "max-date"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("p", _hoisted_7, [
          _createTextVNode(_toDisplayString(_ctx.$t('global.total')) + ":   " + _toDisplayString(_unref(totalTime)) + " ", 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('global.hours')), 1)
        ]),
        (isTotalTimeError.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.$t('total_time_cannot_be_larger_then', { n: maxTotalTime.value })), 1))
          : _createCommentVNode("", true),
        (isEndOnNextDay.value && !isTotalTimeError.value && !isTotalTimeNegative.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.$t('warning_starttime_later_than_endtime')), 1))
          : _createCommentVNode("", true),
        (isTotalTimeNegative.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.$t('total_time_cannot_be_negative')), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(Button), {
        size: "medium",
        color: "outlined",
        onClick: cancel,
        class: "edit-reg-line__btn",
        disabled: isLoading.value
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('global.cancel')), 1)
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_unref(Button), {
        size: "medium",
        onClick: save,
        class: "edit-reg-line__btn",
        disabled: isLoading.value
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('global.save')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _: 1
  }, 8, ["is-open"]))
}
}

})